import React from "react";
import { Box, Divider } from "@mui/material";
import SimpleResultEntry from "./SimpleResultEntry";
import ViewBacklogs from "./ViewBacklogs";
//import WorksheetResultEntry from "./WorksheetResultEntry";
import ReviewCorrectResults from "./ReviewCorrectResults";
import PageUnauthorized from "../PageUnauthorized";
import { GlobalTabCollection, StyledTab } from "../../pages/styles";
import { useAuth } from "../../context/AuthContext";
import { Roles } from "../../constants/roles";

const Analytical = ({ ...props }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const { hasAnyRole } = useAuth();
  const analyticalWorker = hasAnyRole([Roles.AnalyticalWorker, Roles.Developer]);
  const analyticalSME = hasAnyRole([Roles.AnalyticalSME, Roles.Developer]);

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <ViewBacklogs></ViewBacklogs>
      }
      case 1: {
        if (!analyticalSME && tabValue !== 0)
          return <PageUnauthorized/>

        return <ReviewCorrectResults></ReviewCorrectResults>;
      }
      case 2: {
        if (!analyticalWorker && tabValue !== 0)
          return <PageUnauthorized/>

        return <SimpleResultEntry></SimpleResultEntry>;
      }
      // case 3: {
      //   if (!developer && !analyticalWorker && tabValue !== 0)
      //     return <PageUnauthorized/>
      //   return <WorksheetResultEntry></WorksheetResultEntry>;
      // }
      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <>
      <span className='pageheader'>Analytical</span>
      <Divider className='dividerbar' />
      <div>
        <Box sx={{ bgcolor: "#fff", pt:3, pb:1 }}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='View Backlogs' />
            <StyledTab label='Review and Correct Results' />
            <StyledTab label='Simple Result Entry' />
            {/* <StyledTab label='Worksheet Result Entry' /> */}
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default Analytical;
